














































































































import { Component, Vue } from "vue-property-decorator";
import S4Bluetooth from "@/services/bluetoothService";
import { Plugins, Capacitor } from "@capacitor/core";

@Component({})
export default class Home extends Vue {
  pin = "";
  wrongPing = false;
  loading = false;
  dialog = false;
  dialogPin = false;
  dialogDisconnected = false;
  locationAwareCard = false;
  S4 = S4Bluetooth;
  errorMessage = "Incorrect pin. Try Again";
  beforeMount(): void {
    if (this.S4.device) {
      this.$router.replace("/tabs");
    }
  }
  mounted(): void{
    if(!window.localStorage.getItem("isLocationAwareCardAccepted") && Capacitor.getPlatform() === "android"){
      this.locationAwareCard = true;
    }
  }
  close(): void{
      Plugins.App.exitApp();
  }

  requestPermission(): void {
    window.localStorage.setItem("isLocationAwareCardAccepted", "true");      
    this.S4.initialize();
    this.locationAwareCard = false;
  }

  async startScan(): Promise<void> {
    this.loading = true;
    try {
      await this.S4.requestDevice({
        onDisconnect: () => {
          this.$router.replace("/");
          this.dialog = false;
          this.dialogPin = false;
          this.dialogDisconnected = true;
        },
      });
      this.askForPin();
    } catch (error) {
      this.errorMessage = "Unable to Connect to Device";
      if(error.message == "Bluetooth is no enabled") {
        this.errorMessage = "Bluetooth permissions required to scan for devices";        
      }
      this.wrongPing = true;
      this.loading = false;
      console.error(error);
    }
  }

  disconnect(): void {
    this.S4.disconnect();
  }

  askForPin(): void {
    this.dialog = false;
    this.dialogPin = true;
    this.pin = `${this.S4.device?.name?.split(" ").reverse()[0] || ""}`;
  }

  async confirmPin(): Promise<void> {
    this.dialogPin = false;
    try {
      await this.S4.authenticate(this.pin);
      this.$router.replace("/tabs");
    } catch (error) {
      console.error(error);
      this.errorMessage = "Something went wrong. Try Again";
      if(error.message === "Invalid Passphrase" || error.message === "no device connected"){
         this.errorMessage = error.message;
      }
      this.wrongPing = true;
      if(error.message !== "no device connected")
        setTimeout(() => {
          this.askForPin();
        }, 1000);
    }
  }
}
